module.exports = __webpack_public_path__ + "mobile/img/icon_home_nav_logo2.921dc82d.png";